import type { ReactNode } from "react";
import { MayflowerLogo } from "@/shadcn/mayflower-logo";

interface VoiceLayoutProps {
  children: ReactNode;
}

export function VoiceLayout({ children }: Readonly<VoiceLayoutProps>) {
  return (
    <div className="flex min-h-screen flex-col items-center bg-background px-4 py-10">
      <header className="mb-8 flex w-full max-w-md items-center justify-center">
        <MayflowerLogo className="h-7" />
      </header>
      <main className="w-full max-w-md">{children}</main>
    </div>
  );
}
